import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/email-template-defaults/main/loading';

export const Route = createFileRoute('/_private/settings/email-template-defaults/')({
  staticData: { isFullWidth: false },
  pendingComponent: Loading,
});
